import {
  RowDataTypes,
  admin,
  member,
  transaction,
  staff,
  main,
  kpiObjective,
  banner,
  kpi,
  voucher,
  notification,
  orders,
  merchandise,
  dealer,
  priceListPDF,
  splashScreen,
  prebuild,
  terms,
  corporate,
  dealerRebate,
  bdayVoucher,
  pcComponent,
  pcComponentParameter,
  storeItem,
  allItem,
  gpu,
  games,
  buildConfigPrebuild,
  buildConfigCustom,
  bannerWeb,
  review,
  webOrder,
  contactUs,
  buildConfigEasy,
  contact,
  pdfGpu,
} from "../components/types/RowDataTypes";

//Key-value pair mapping enum of row data types to their approriate string index when accessing the fetched data object
export const fetchRowDataErrorMessages: { [key in RowDataTypes]: string } = {
  [admin]: "Admin - Network Error",
  [member]: "Member - Network Error",
  [transaction]: "Transaction - Network Error",
  [staff]: "Staff - Network Error",
  [kpi]: "KPI Staff - Network Error",
  [main]: "Main - Network Error",
  [kpiObjective]: "KPI -  Network Error",
  [banner]: "Banner - Network Error",
  [voucher]: "Voucher - Network Error",
  [notification]: "Notification - Network Error",
  [orders]: "Order - Network Error",
  [merchandise]: "Notification - Network Error",
  [dealer]: "Dealer - Network Error",
  [priceListPDF]: "PDF Price List - Network Error",
  [splashScreen]: "Splash Screen - Network Error",
  [prebuild]: "Prebuild - Network Error",
  [terms]: "Terms - Network Error",
  [corporate]: "Corporate - Network Error",
  [dealerRebate]: "Dealer Rebate - Network Error",
  [bdayVoucher]: "Birthday Voucher - Network Error",
  [pcComponent]: "PC Component - Network Error",
  [pcComponentParameter]: "PC Component Parameter - Network Error",
  [storeItem]: "Store Item - Network Error",
  [allItem]: "All Item - Network Error",
  [gpu]: "GPU - Network Error", 
  [games]: "Games - Network Error",
  [buildConfigPrebuild]: "Prebuild PC - Network Error",
  [buildConfigCustom]: "Custom PC - Network Error",
  [bannerWeb]: "Banner - Network Error",
  [review]: "Review - Network Error",
  [webOrder]: "Web Order - Network Error",
  [contactUs]: "Contact Us - Network Error",
  [buildConfigEasy]: "Easy Build - Network Error",
  [contact]: "Contact - Network Error",
  [pdfGpu]: "PdfGpu - Network Error",
};
